import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";

export default function WaitlistPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("email", email);
        formData.append("timestamp", new Date().toISOString());

        const scriptUrl = process.env.REACT_APP_GOOGLE_SHEETS_URL;
        
        if (scriptUrl) {
          await fetch(scriptUrl, {
            method: "POST",
            body: formData,
            mode: "no-cors",
          });
        } else {
          console.warn("REACT_APP_GOOGLE_SHEETS_URL is not set.");
        }
        
        setSubmitted(true);
      } catch (error) {
        console.error("Error submitting form", error);
        // We still show submitted state to the user even if there's a problem, 
        // to prevent them from clicking repeatedly.
        setSubmitted(true);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient" style={{ display: 'flex', flexDirection: 'column' }}>
      <nav className="nav">
        <div className="container">
          <div className="nav-inner">
            <Link to="/" className="logo" style={{ textDecoration: 'none' }}>
              <img src="/cirupay-logo-compact.svg" alt="CiruPay Logo" className="logo-image" />
            </Link>
          </div>
        </div>
      </nav>

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyItems: 'center', padding: '1rem' }}>
        <div className="wip-dialog" style={{ position: 'relative', margin: '0 auto', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)' }}>
          <div className="wip-icon">✉️</div>
          <h2 className="wip-title">Join the Waitlist</h2>
          <p className="wip-message" style={{ marginBottom: '2rem' }}>
            Be the first to know when CiruPay launches. Enter your email below to get early access.
          </p>
          
          {submitted ? (
            <div style={{ background: '#ecfdf5', padding: '1rem', borderRadius: '0.5rem', color: '#047857', fontWeight: 600 }}>
              Thanks for joining! We'll be in touch soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <input 
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address" 
                required
                style={{
                  padding: '1rem',
                  borderRadius: '0.5rem',
                  border: '1px solid #d1d5db',
                  fontSize: '1rem',
                  width: '100%',
                  outline: 'none',
                }}
              />
              <button 
                type="submit" 
                className="btn btn-lg" 
                style={{ width: '100%', opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Join Waitlist"}
              </button>
            </form>
          )}

          <div style={{ marginTop: '2rem' }}>
             <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#059669', cursor: 'pointer', fontWeight: 600, fontSize: '1rem' }}>
               &larr; Back to Home
             </button>
          </div>
        </div>
      </main>
    </div>
  );
}
